import { Input } from "reactstrap";
import { useState } from "react";

import { FileDndWithHeader } from "../../BuildTab/components/FileDnd";
import { uploadImage } from "../../../../../utils/GeneralUtils";
import { RemoveImage } from "../../BuildTab/components/Header";
import { FormSettingsProps } from "./PostSubmit";

export default function PageSettings({ form, setForm }: FormSettingsProps) {
  const [uploading, setUploading] = useState(false);

  const handleSetForm = (value: any, key: string) => {
    setForm({ ...form.PageSettings, [key]: value }, "PageSettings");
  };

  const handleUploadImage = (apiName: string) => async (e: any) => {
    setUploading(true);
    const sourceList: any = form?.id
      ? [
          {
            Source: "Record",
            SourceID: form?.id,
            SourceModule: "Forms",
            FieldAPIName: `PageSettings.${apiName}`,
          },
        ]
      : undefined;

    try {
      const data = await uploadImage(
        e.target.files[0],
        true,
        true,
        true,
        sourceList
      );

      if (typeof data === "string") return;

      const imageObject = data.files[0];

      handleSetForm(imageObject, apiName);
    } catch {
    } finally {
      setUploading(false);
    }
  };

  const handleRemoveImage = () => {
    RemoveImage(
      form?.id ?? "",
      "PageSettings.Favicon",
      form?.PageSettings?.id || "",
      form?.PageSettings?.Favicon
    );

    handleSetForm({}, "Favicon");
  };

  return (
    <div className="text-sm font-weight-500 text-dark mb-4">
      <label className="mb-0">Page Title</label>
      <Input
        value={form.PageSettings?.Title || ""}
        bsSize="sm"
        onChange={(e) => handleSetForm(e.target.value, "Title")}
        className="my-2"
      />
      <div>
        <label className="mb-0 mt-3">Metadescription</label>
      </div>
      <Input
        type="textarea"
        value={form.PageSettings?.Description || ""}
        bsSize="sm"
        onChange={(e) => handleSetForm(e.target.value, "Description")}
        className="my-2"
      />
      <FileDndWithHeader
        upload={handleUploadImage("Favicon")}
        uploading={uploading}
        handleRemoveImage={() => handleRemoveImage()}
        title="Favicon"
        file={form.PageSettings?.Favicon?.PublicURL}
      />
    </div>
  );
}
